import { render, staticRenderFns } from "./ObjectAuthorizationList.vue?vue&type=template&id=669aac9b&scoped=true&"
import script from "./ObjectAuthorizationList.vue?vue&type=script&lang=ts&"
export * from "./ObjectAuthorizationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669aac9b",
  null
  
)

export default component.exports